<!--
 * @Description:
 * @Author: Ingyi
 * @Date: 2021-09-05 20:31:49
 * @LastEditors: Ingyi
 * @LastEditTime: 2021-09-05 20:31:49
-->
<template>
  <div class="user-center-index">
    <!-- 上半部分，头像+基础信息 -->
    <div class="titBox">
      <div class="titBox_imgBox">
        <img
          src="../assets/img/default _user.png"
          @click="$router.push('http://sbj.cnipa.gov.cn/sbcx/')"
        />
      </div>
      <div class="titBox_conBox">
        <!-- <p>欢迎{{ userInfo.name }}您回来 </p> -->
        <div>
          <el-button type="primary" size="small" @click="editPassword"
            >修改密码</el-button
          >
        </div>
      </div>
    </div>
    <!-- 中间部分 -->
    <div class="bottomBox">
      <div>
        <p>您已发布了{{ this.userCount.projectCount }}个项目</p>
        <button @click="() => $router.push({ path: '/userCenter/project' })">
          点击查看
        </button>
      </div>
      <div>
        <p>您已发布了{{ this.userCount.sppplyCount }}个供应</p>
        <button @click="() => $router.push({ path: '/userCenter/supply' })">
          点击查看
        </button>
      </div>
      <div>
        <p>您已发布了{{ this.userCount.demandCount }}个需求</p>
        <button @click="() => $router.push({ path: '/userCenter/demand' })">
          点击查看
        </button>
      </div>
      <div>
        <p>您已申报了{{ this.userCount.shenCount }}项政策</p>
        <button @click="() => $router.push({ path: '/userCenter/shen' })">
          点击查看
        </button>
      </div>
    </div>
    <!-- 推荐列表 -->
    <div>
      <p class="listBox_tit">项目推荐</p>
      <!-- 交易服务 -->
      <div class="trade">
        <div class="good-list">
          <div
            class="good-item blue"
            v-for="item in project"
            :key="item.id"
            @click="
              () =>
                $router.push({ path: '/projectDetail', query: { id: item.id } })
            "
          >
            <img v-if="item.videoId" :src="item.videoId" />
            <span>{{ item.title }}</span>
            <a>{{ item.money == 0 ? '面议' : item.money }}</a>
          </div>
        </div>
      </div>
    </div>
    <!-- 修改密码弹出层 -->
    <el-dialog
      title="修改密码"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
    >
      <div>
        <el-form
          ref="ruleForm"
          :rules="rules"
          :model="form"
          label-width="100px"
        >
          <el-form-item label="新密码：" prop="newPassword">
            <el-input
              v-model="form.newPassword"
              placeholder="请输入新密码"
              show-password
            ></el-input>
          </el-form-item>
          <el-form-item label="确认密码：" prop="newPassword1">
            <el-input
              v-model="form.newPassword1"
              placeholder="请确认密码"
              show-password
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false" size="small">取 消</el-button>
        <el-button type="primary" @click="btnOk('ruleForm')" size="small"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
var that = this
import request from "@/util/request.js";
import { encrypt } from "@/util/jsencrypt";
export default {
  name: "user-center-index",
  data() {
    const checkRewardKey = (rule, value, callback) => {
      if (value === '') {
        return callback(new Error('请输入密码'))
      }
      // if (value.length != 8) {
      //   return callback(new Error('密码长度为8个字符'))
      // }

      if (/[\u4E00-\u9FA5]/g.test(value)) {
        return callback(new Error('不能输入汉字'))
      }
      return callback();
    }
    return {
      userInfo: {},
      project: [],
      userCount: {},
      dialogVisible: false,
      form: {
        password: '',
        newPassword: '',
        newPassword1: ''
      },
      paramValue: {},
      rules: {
        newPassword: [
          { validator: checkRewardKey, trigger: 'blur' }

        ],
        newPassword1: [
          { validator: checkRewardKey, trigger: 'blur' }
        ]
      }
    };
  },
  mounted() {
    const userInfo = localStorage.getItem("userInfo");
    if (userInfo) this.userInfo = JSON.parse(userInfo);
    this.quertProject();
    this.quertUserCount();
  },
  methods: {
    //推荐项目
    quertProject() {
      request({
        url: "/api/client/common/project/recommend",
      }).then((res) => {
        if (res.code == "200") {
          this.project = res.data;
        } else {
          this.$message.warning(res.msg);
        }
      });
    },
    //个人统计
    quertUserCount() {
      request({
        url: "/api/tool/user/client/infocount",
      }).then((res) => {
        if (res.code == "200") {
          this.userCount = res.data;
        } else {
          this.$message.warning(res.msg);
        }
      });
    },
    //修改密码
    editPassword() {
      this.dialogVisible = true
      this.form = {
        newPassword: '',
        newPassword1: ''
      }
    },
    //确定
    btnOk() {
      if (this.form.newPassword != this.form.newPassword1) {
        this.$message.warning('两次输入的密码不一致');
      } else {
        this.$refs.['ruleForm'].validate((valid) => {
          if (valid) {
            // this.paramValue.newPassword = encrypt(this.form.newPassword)
            // console.log(this.paramValue);
            request({
              url: "/api/client/login/updatepassword",
              method: "put",
              // newPassword: this.paramValue.newPassword,
              params: { newPassword: this.form.newPassword },
            }).then((res) => {
              if (res.code == "200") {
                this.$message.success("修改成功");
                this.dialogVisible = false
                console.log(this.form);
                this.form = {
                  newPassword: '',
                  newPassword1: ''
                }
              } else {
                this.$message.warning(res.msg);
              }
            });

          } else {
            console.log('校验不通过');
          }
        });
      }




    },
    //关闭
    handleClose(done) {
      this.dialogVisible = false
    }
  }
};
</script>
<style lang="less">
.listBox_tit {
  color: #2288ed;
  border-left: 4px solid #2288ed;
  padding-left: 8px;
  font-size: 14px;
  margin: 40px 0 20px;
}

.bottomBox {
  width: 100%;
  border-top: 1px solid #95cdd0;
  display: flex;
  justify-content: space-between;

  button {
    background: #2288ed;
    color: #fff;
    border-radius: 5px;
    width: 125px;
    height: 35px;
  }

  div {
    width: 25%;
    border: 1px solid #dbdbdb;
    margin: 20px 5px 0px 5px;
    text-align: center;
    padding: 20px 0px;
    border-radius: 5px;
  }
}

.titBox {
  width: 100%;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #95cdd0;
  padding-bottom: 20px;
  margin-bottom: 8px;
}

.titBox_imgBox {
  width: 30%;

  img {
    width: 100px;
    height: 100px;
    background: #f4f4f4;
    border-radius: 100%;
    margin-left: 50px;
  }
}

.titBox_conBox {
  font-size: 18px;
  font-weight: 700;
  padding-right: 500px;
  //padding-top: 20px;

  p {
    width: 200px;
  }
}

.user-center-index {
  margin: 40px;

  .table {
    padding: 40px;
  }
}

// 交易服务
.trade {
  width: 100%;
  margin: 40px auto;

  .trade_title {
    margin: 0 auto;
    font-size: 28px;
    font-weight: bold;
    color: #1890ff;
    text-align: center;
    width: fit-content;

    span:first-child::after {
      content: '';
      display: block;
      width: 50px;
      margin-left: 35px;
      height: 2px;
      background: #1890ff;
    }

    .more {
      padding: 5px 4px;
      border: 1px solid #ccc;
      font-size: 15px;
      color: #999;
    }
  }

  .tag-list {
    display: flex;
  }

  .tags {
    font-size: 18px;
    width: 160px;
    height: 50px;
    color: #666;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .active {
    color: #fff;
    background: #008cd7;
    border-radius: 50px;
  }

  .good-list {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;

    .good-item {
      width: 200px;
      height: 260px;
      margin-top: 20px;
      background: #fff;
      display: flex;
      flex-direction: column;
      // justify-content: space-between;
      align-items: center;

      img {
        width: 200px;
        height: 200px;
        margin-bottom: 0px;
      }

      span {
        margin-bottom: 10px;
      }

      a {
        color: #ec967d;
      }
    }

    .blue {
      background: #f0f7ff;
    }
  }
}
</style>
